// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fsjZStpoX4ZCLqzrNRT6 {
  display: flex;
  column-gap: 0.75rem;
  align-items: flex-start;
  width: fit-content;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  border: 1.5px solid #dbdbdb;
  border-radius: 3px;
  transition: all 0.2s;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw .K38tQrD83pJkQddunyl7 {
  opacity: 1;
  visibility: visible;
  transition: all 0.2s;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw .K38tQrD83pJkQddunyl7 path {
  stroke: #dbdbdb;
  transition: all 0.2s;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw .b7QvX3yQu7MIpSuuPz4c {
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:hover {
  transition: all 0.2s;
  border-color: #fff;
  cursor: pointer;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:hover .b7QvX3yQu7MIpSuuPz4c {
  transition: all 0.2s;
  opacity: 0.2;
  color: #222;
  visibility: visible;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:hover .b7QvX3yQu7MIpSuuPz4c path {
  transition: all 0.2s;
  stroke: #fff;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:hover .K38tQrD83pJkQddunyl7 path {
  transition: all 0.2s;
  stroke: #fff;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:active {
  transition: all 0.2s;
  border-color: rgba(0, 0, 0, 0.1254901961);
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:active .K38tQrD83pJkQddunyl7,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:active .b7QvX3yQu7MIpSuuPz4c {
  transition: all 0.2s;
  visibility: visible;
  opacity: 0.2;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:active .K38tQrD83pJkQddunyl7 path,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .mAs5Gu5C5IuYBNYjjWqw:active .b7QvX3yQu7MIpSuuPz4c path {
  transition: all 0.2s;
  stroke: #222;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:hover,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:active {
  border-color: #474747;
  transition: all 0.2s;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2 .K38tQrD83pJkQddunyl7,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:hover .K38tQrD83pJkQddunyl7,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:active .K38tQrD83pJkQddunyl7 {
  opacity: 1;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2 .K38tQrD83pJkQddunyl7 path,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:hover .K38tQrD83pJkQddunyl7 path,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:active .K38tQrD83pJkQddunyl7 path {
  transition: all 0.2s;
  stroke: #474747;
}
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2 .b7QvX3yQu7MIpSuuPz4c,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:hover .b7QvX3yQu7MIpSuuPz4c,
.fsjZStpoX4ZCLqzrNRT6 .MNq1ufhW9aupxgmBEUjc .QHeeCbIhHCbYxj93AaZ2:active .b7QvX3yQu7MIpSuuPz4c {
  visibility: hidden;
  opacity: 0;
}
.fsjZStpoX4ZCLqzrNRT6 .hn7oJQHA7dUYj785Q9wY {
  display: flex;
  justify-content: flex-start;
  font-size: 1rem;
  line-height: 1.1875rem;
  font-weight: 400;
  color: #fff;
  transition: all 0.2s;
}
.fsjZStpoX4ZCLqzrNRT6 .hn7oJQHA7dUYj785Q9wY:hover {
  cursor: pointer;
}
.fsjZStpoX4ZCLqzrNRT6 .q91pEycKZ6C70UTREjrK {
  transition: all 0.3;
  color: #474747;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Checkbox/Checkbox.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;AAAN;AAEM;EACE,UAAA;EACA,mBAAA;EACA,oBAAA;AAAR;AAEQ;EACE,eCRM;EDSN,oBAAA;AAAV;AAIM;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;AAFR;AAKM;EACE,oBAAA;EACA,kBC5BA;ED6BA,eAAA;AAHR;AAKQ;EACE,oBAAA;EACA,YAAA;EACA,WCXF;EDYE,mBAAA;AAHV;AAKU;EACE,oBAAA;EACA,YCvCJ;ADoCR;AAOQ;EACE,oBAAA;EACA,YC7CF;ADwCR;AASM;EACE,oBAAA;EACA,yCAAA;AAPR;AASQ;;EAEE,oBAAA;EACA,mBAAA;EACA,YAAA;AAPV;AASU;;EACE,oBAAA;EACA,YCtCJ;ADgCR;AAYI;;;EAGE,qBClDK;EDmDL,oBAAA;AAVN;AAYM;;;EACE,UAAA;AARR;AAUQ;;;EACE,oBAAA;EACA,eC1DC;ADoDX;AAUM;;;EACE,kBAAA;EACA,UAAA;AANR;AAWE;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,WC/FI;EDgGJ,oBAAA;AATJ;AAWI;EACE,eAAA;AATN;AAaE;EACE,mBAAA;EACA,cCrFO;AD0EX","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `fsjZStpoX4ZCLqzrNRT6`,
	"checkboxContainer": `MNq1ufhW9aupxgmBEUjc`,
	"checkbox": `mAs5Gu5C5IuYBNYjjWqw`,
	"checkedIcon": `K38tQrD83pJkQddunyl7`,
	"uncheckedIcon": `b7QvX3yQu7MIpSuuPz4c`,
	"disabledCheckbox": `QHeeCbIhHCbYxj93AaZ2`,
	"label": `hn7oJQHA7dUYj785Q9wY`,
	"disabledLabel": `q91pEycKZ6C70UTREjrK`
};
export default ___CSS_LOADER_EXPORT___;
